import { createContext } from 'react';
import { QueueStore } from '../store/queue-store';
import { RawQueueRowData } from '../store/types-2';

export const QueueStateContext = createContext<QueueStore<RawQueueRowData> | undefined>(undefined);
